/**
 * Copyright (c) 2020 TechDivision GmbH
 * All rights reserved
 */

;(function StickySidebar() {
    /**
     * handle the functionality of the sticky sidebar
     *
     * @constructor
     */
    function stickySidebar(stickySidebarDom) {
        /**
         * local object availability
         * @type {stickySidebar}
         * @private
         */
        var _this = this

        /**
         * Outer width of the icons
         * @type {int}
         * @private
         */
        this.iconsOuterWidth = 0

        /**
         * Outer width (width including padding and border) of the stickySidebar
         * @type {int}
         * @private
         */
        this.stickySidebarOuterWidth = stickySidebarDom.offsetWidth

        /**
         * current state whether the stickySidebar is collapsed
         * @type {boolean}
         * @private
         */
        this.isCollapsed = true

        /**
         * Bind the on click event of the stickySidebar to toggle the collapse state
         * @method bindEvents
         * @returns {undefined}
         */
        this.bindEvents = function () {
            stickySidebarDom.addEventListener('click', function () {
                if (_this.isCollapsed) {
                    _this.showStickySidebar()
                } else {
                    _this.hideStickySidebar()
                }
                _this.isCollapsed = !_this.isCollapsed
            })
        }

        /**
         * Hide the stickySidebar. This shows only the icons
         * @method hideStickySidebar
         * @returns {undefined}
         */
        this.hideStickySidebar = function () {
            stickySidebarDom.style.left = 'unset'
            stickySidebarDom.style.right = -_this.stickySidebarOuterWidth + _this.iconsOuterWidth + 'px'
        }

        /**
         * Show the stickySidebar. This shows the icons and the corresponding text
         * @method showStickySidebar
         * @returns {undefined}
         */
        this.showStickySidebar = function () {
            stickySidebarDom.style.right = 0
        }

        /**
         * Calculate the outer width of the icons
         * @method calculateIconsOuterWidth
         * @returns {undefined}
         */
        this.calculateIconsOuterWidth = function () {
            var iconWidth = stickySidebarDom.querySelector('.sticky-sidebar__icon').offsetWidth
            var stickySidbarPaddingInPx = window.getComputedStyle(stickySidebarDom).padding
            var stickySidebarPadding = Number.parseInt(stickySidbarPaddingInPx.replace('px', ''))
            _this.iconsOuterWidth = iconWidth + 2 * stickySidebarPadding
        }

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            _this.calculateIconsOuterWidth()
            _this.hideStickySidebar()
            _this.bindEvents()
        }

        /**
         * initialize call
         */
        this.init()
    }

    // define the global scope
    if (!window.Energy) {
        window.Energy = {}
    }

    window.Energy.stickySidebar = stickySidebar
})()

function initStickySidebar() {
    var stickySidebar = document.querySelector("[data-js='sticky-sidebar']")
    if (stickySidebar) {
        new window.Energy.stickySidebar(stickySidebar)
    }
}

if (document.readyState !== 'loading') {
    initStickySidebar()
} else {
    document.addEventListener('DOMContentLoaded', function () {
        initStickySidebar()
    })
}
